<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10kNju6/tc-custom/9783985317271.jpg" alt="This image is the cover for the book The Lost Continent, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Lost Continent, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: "We were both of us not a little stiff as the result of sleeping out in the open all that night, for even in Grand Canary the dew-fall and the comparative chill of darkness are not to be trifled with. For myself on these occasions I like a bit of a run as an early refresher. But here on this rough ground in the middle of the island there were not three yards of level to be found, and so as Coppinger proceeded to go through some sort of dumb-bell exercises with a couple of lumps of bristly lava, I followed his example. Coppinger has done a good deal of roughing it in his time, but being a doctor of medicine amongst other things—he takes out a new degree of some sort on an average every other year—he is great on health theories, and practises them like a religion. There had been rain two days before, and as there was still a bit of stream trickling along at the bottom of the barranca, we went down there and had a wash, and brushed our teeth. Greatest luxury imaginable, a toothbrush, on this sort of expedition. “Now,” said Coppinger when we had emptied our pockets, “there’s precious little grub left, and it’s none the better for being carried in a local Spanish newspaper.” “Yours is mostly tobacco ashes.” “It’ll get worse if we leave it. We’ve a lot more bad scrambling ahead of us.” That was obvious. So we sat down beside the stream there at the bottom of the barranca, and ate up all of what was left. It was a ten-mile tramp to the fonda at Santa Brigida, where we had set down our traps; and as Coppinger wanted to take a lot more photographs and measurements before we left this particular group of caves, it was likely we should be pretty sharp set before we got our next meal, and our next taste of the PATRON’S splendid old country wine. My faith! If only they knew down in the English hotels in Las Palmas what magnificent wines one could get—with diplomacy—up in some of the mountain villages, the old vintage would become a thing of the past in a week."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles John Cutcliffe Wright Hyne
      </h2>
      
      <p class="authorDescription body article">Charles John Cutcliffe Wright Hyne (11 May 1866 – 10 March 1944) was an English novelist who was also known by the pen name Weatherby Chesney. He is perhaps best remembered as the author of The Lost Continent: The Story of Atlantis. He is also remembered for his Captain Kettle stories and for The Recipe for Diamonds.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eb351b3c